import { render, staticRenderFns } from "./WeeklyMenu.vue?vue&type=template&id=20de0af0&scoped=true"
import script from "./WeeklyMenu.vue?vue&type=script&lang=js"
export * from "./WeeklyMenu.vue?vue&type=script&lang=js"
import style0 from "./WeeklyMenu.vue?vue&type=style&index=0&id=20de0af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de0af0",
  null
  
)

export default component.exports